<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 17 32"
  >
    <g :fill="color" class="fill-current">
      <path
        d="M16.614 31.748l0.509-0.509c0.156-0.156 0.253-0.372 0.253-0.61s-0.097-0.454-0.253-0.61v0l-14.023-14.015 14.023-14.022c0.156-0.156 0.253-0.372 0.253-0.61s-0.097-0.454-0.253-0.61v0l-0.509-0.509c-0.156-0.156-0.372-0.253-0.61-0.253s-0.454 0.097-0.61 0.253v0l-15.142 15.134c-0.156 0.156-0.253 0.372-0.253 0.61s0.097 0.454 0.253 0.61v0l15.142 15.134c0.156 0.16 0.373 0.259 0.613 0.259 0.237 0 0.451-0.096 0.606-0.252l0-0z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
